import {Breakpoints} from '@angular/cdk/layout';
import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

import {firstValueFrom, from} from 'rxjs';

import {
  BaseTableFilteredComponent,
  basicDeleteTemplateOptions,
  basicEditTemplateOptions,
  TableContextMenu,
  TableField,
  TableFilterType,
  TableSortType,
  UiTableComponent,
} from '@ui/ui.module';

import {SwalService} from '@atmi/core';

import {Collection, CollectionFilter, CollectionFilterMeta} from '../../models/collection';
import {CollectionApiService} from '../../services/collection-api.service';
import {CollectionFiltersComponent} from '../collection-filters/collection-filters.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-collections',
  styleUrls: ['./collections.component.scss'],
  templateUrl: './collections.component.html',
})
export class CollectionsComponent
  extends BaseTableFilteredComponent<Collection, CollectionFilter>
  implements UiTableComponent<Collection>, OnInit {

  readonly MobileFiltersComponent = CollectionFiltersComponent;

  // Default sort configuration: sort by updatedAt in descending order
  readonly defaultSort: TableSortType = [{ field: 'updatedAt', type: 'desc' }];

  readonly fields: TableField<Collection>[] = [
    {
      header: '',
      hideBreakpoints: [Breakpoints.XSmall],
      key: 'chekbox',
      selectable: true,
    },
    {
      align: 'center',
      header: '',
      hideBreakpoints: [Breakpoints.XSmall],
      key: 'edit',
      template: 'edit',
      width: -70,
    },
    {
      header: this.translate.instant('Titolo'),
      key: 'titolo',
    },
    {
      header: this.translate.instant('Descrizione'),
      key: 'descrizione',
    },
    {
      header: this.translate.instant('Data creazione'),
      hideBreakpoints: [Breakpoints.XSmall],
      key: 'createdAt',
      template: 'date-time',
    },
    {
      header: this.translate.instant('Data aggiornamento'),
      hideBreakpoints: [Breakpoints.XSmall],
      key: 'updatedAt',
      template: 'date-time',
      sortable: true,
    },
    {
      align: 'center',
      header: '',
      hideBreakpoints: [Breakpoints.XSmall],
      key: 'delete',
      template: 'delete',
      width: -70,
    },
    {
      align: 'right',
      header: '',
      key: 'context',
      showBreakpoints: [Breakpoints.XSmall],
      template: 'context',
    },
  ];

  readonly pager$ = ((page?: number, limit?: number, sort?: TableSortType, filter?: TableFilterType) =>
      this.collectionApi.index({page, limit, sort, filter})
  );

  // readonly contextMenus: Array<TableContextMenu<Collection>> = [
  //   {
  //     action: (item) => this.editShowHandler(item),
  //     label: this.translate.instant('Modifica'),
  //   },
  //   {
  //     action: (item) => item.id ? this.deleteHandler(item.id) : () => undefined,
  //     label: this.translate.instant('Elimina'),
  //   },
  // ];

  constructor(
    private readonly collectionApi: CollectionApiService,
    protected readonly route: ActivatedRoute,
    protected readonly router: Router,
    protected readonly swalService: SwalService,
    protected readonly translate: TranslateService,
  ) {
    super(translate, router, route, CollectionFilterMeta, swalService);

    this.fields.push(basicEditTemplateOptions);
    this.fields.push(basicDeleteTemplateOptions);
  }

  ngOnInit() {
    // Default sort is now handled by the defaultSort property
    // which is passed to the table component via the template
  }

  deleteConcreteHandler(id: string) {
    return this.collectionApi.remove(id);
  }

  deleteSelectedConcreteHandler(ids: string[]) {
    const deleteApis = ids.map((id) => firstValueFrom(this.collectionApi.remove(id)));

    return from(Promise.all(deleteApis));
  }
}
